<section class="popular-links" appIsVisible (isVisible)="initializePopularLinksView()">
  <h3 *ngIf="title" class="popular-links__title">{{ title }}</h3>

  <ng-container *ngTemplateOutlet="!isMobile ? desktopPopularLinks : mobilePopularLinks"></ng-container>

  <ng-template #desktopPopularLinks>
    <app-popular-links-desktop
      class="popular-links__desktop"
      [cardList]="linkList"
    ></app-popular-links-desktop>
  </ng-template>

  <ng-template #mobilePopularLinks>
    <app-popular-links-mobile [cardList]="linkList"></app-popular-links-mobile>
  </ng-template>
</section>
